import React from 'react';

const PaymentFailed = () => {
    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', background: 'linear-gradient(to right, #ff4e50, #f9d423)' }}>
            <div style={{ textAlign: 'center', padding: '20px', borderRadius: '10px', background: 'white', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)' }}>
                <h1 style={{ color: '#ff4e50', fontSize: '2rem', marginBottom: '10px' }}>Payment Failed</h1>
                <p style={{ color: '#555', fontSize: '1rem' }}>Please try again or contact support.</p>
            </div>
        </div>
    );
}

export default PaymentFailed;
